import { ExamesListSearchComponent } from './ExamesListSearchComponent'
import { ExamesListToolbar } from './ExamesListToolbar'

export const ExamesListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
      <ExamesListSearchComponent actions={<ExamesListToolbar />} />
    </div>
  )
}
